import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'uni-auxiliary-filter',
  templateUrl: './auxiliary-filter.component.html',
  styleUrls: ['./auxiliary-filter.component.scss']
})
export class AuxiliaryFilterComponent implements OnInit {
  @Input() filterTitle: string;
  @Input() type: string;
  @Input() options: string[];
  @Input() chosenOption: string;
  @Input() align: 'right' | 'left' = 'left';
  @Output() setOption = new EventEmitter();

  showOptions: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  setSelectedOption(option: string): void {
    this.chosenOption = option;
    this.setOption.emit(this.chosenOption);
  }
}
